const COMMENT_LOCATIONS = {
  "1-1": "Skąd eksportujesz?",
  "1-2": "Dane eksportera i wnioskodawcy",
  "1-3": "Kim jest eksporter?",
  "1-4": "Transport",
  "2-1": "Produkty / Towary - dodawanie",
  "2-2": "Podsumowanie",
  "3-2": "Odbiorca",
  "4-1": "Załączniki obowiązkowe",
  "4-2": "Załączniki do towarów",
  "4-3": "Załączniki do produktów",
  "4-4": "Załączniki - dodatkowe informacje",
  "4-5": "Uwagi operatora na wniosku",
  "5-1": "Podsumowanie",
  "5-2": "Załączniki",
  "5-3": "Oświadczenia",
  "5-4": "Dostawa i opłaty",
  "5-5": "Uwagi",
};

const getCommentLocation = (step, comment) => {
  if (comment.locationName) return comment.locationName;
  if (COMMENT_LOCATIONS[comment.id]) return COMMENT_LOCATIONS[comment.id];

  if (String(comment.id).startsWith("2-1-")) {
    return "Eksportowany produkt / towar";
  }

  if (String(comment.id).startsWith("3-1-")) {
    return String(comment.id).split("-").length > 3
      ? "Proces produkcji - produkt"
      : "Proces produkcji";
  }

  return `Krok ${step}`;
};

/**
 * Zwraca aktywne uwagi operatora przeznaczone dla wnioskodawcy.
 * Rozmowa znika z agregacji po odpowiedzi klienta, bez zmiany istniejącej
 * logiki statusów konwersacji.
 */
export const getOpenOperatorRemarks = (applicationContent) => {
  if (!applicationContent) return [];

  const remarks = [];

  for (let step = 1; step <= 5; step += 1) {
    const comments = applicationContent[`Step_${step}`]?.Comments || [];

    comments.forEach((comment) => {
      if (
        comment?.status !== "open" ||
        comment?.id === "CaseCommunication"
      ) {
        return;
      }

      const conversation = comment.Conversation || [];
      const latestMessage = conversation[conversation.length - 1];

      if (
        latestMessage?.authorRole !== "operator" ||
        !latestMessage?.text
      ) {
        return;
      }

      remarks.push({
        id: String(comment.id),
        step,
        location: getCommentLocation(step, comment),
        text: latestMessage.text,
        author: latestMessage.author,
        createDate: latestMessage.createDate,
      });
    });
  }

  return remarks;
};

